
import React from 'react';

interface SeasonalBannerProps {
  heading: string;
  subheading: string;
}

const SeasonalBanner: React.FC<SeasonalBannerProps> = ({ heading, subheading }) => {
  return (
    <div className="bg-[#5E6C2F] text-white py-4 px-6 text-center">
      <p className="text-lg font-semibold">{heading}</p>
      <p className="text-sm">{subheading}</p>
    </div>
  );
};

export default SeasonalBanner;
